import { message } from 'antd';
import { apiHolder as api, apis, isElectron } from 'api';
import { useEffect, useRef } from 'react';
const systemApi = api.api.getSystemApi();
const eventApi = api.api.getEventApi();
const loginApi = api.api.requireLogicalApi(apis.loginApiImpl);
const useRisk = () => {
    const navListenIdRef = useRef(null);
    const originReqRef = useRef(null);
    const sucCallbackRef = useRef(null);
    const failCallbackRef = useRef(null);
    const startWillNavigateListen = () => {
        (navListenIdRef === null || navListenIdRef === void 0 ? void 0 : navListenIdRef.current) && eventApi.unregisterSysEventObserver('willNavigate', navListenIdRef.current);
        const id = eventApi.registerSysEventObserver('willNavigate', {
            name: 'willNavigateListen',
            func: async (ev) => {
                var _a;
                if (ev && (ev === null || ev === void 0 ? void 0 : ev.eventData)) {
                    const { data, winId } = ev.eventData;
                    const { host, search, searchParams } = new URL((data === null || data === void 0 ? void 0 : data.url) || '');
                    if (!search)
                        return;
                    const csplToken = searchParams.get('csplToken');
                    const msg = searchParams.get('msg');
                    const msgHl = searchParams.get('msgHl');
                    const cancelRisk = searchParams.get('cancelRisk');
                    if (csplToken) {
                        try {
                            window.electronLib.windowManage.closeCertainWindow(winId);
                            let subAccountMsg = null;
                            const { req, email } = (originReqRef === null || originReqRef === void 0 ? void 0 : originReqRef.current) || {};
                            const { isSubAccount, sessionName } = req || {};
                            if (isSubAccount) {
                                subAccountMsg = {
                                    isSubAccount,
                                    sessionName,
                                    acccount: email,
                                };
                            }
                            const res = await loginApi.csplLogin(Object.assign(Object.assign({}, originReqRef.current), { req: Object.assign(Object.assign({}, (_a = originReqRef === null || originReqRef === void 0 ? void 0 : originReqRef.current) === null || _a === void 0 ? void 0 : _a.req), { csplToken }), subAccountMsg }));
                            (sucCallbackRef === null || sucCallbackRef === void 0 ? void 0 : sucCallbackRef.current) && sucCallbackRef.current(res);
                        }
                        catch (error) {
                            console.error('url变更解析失败', error);
                        }
                    }
                    if (host && host.includes('qy.163.com') && msg && msgHl) {
                        window.electronLib.windowManage.closeCertainWindow(winId);
                        message.error(decodeURIComponent(msgHl));
                        (failCallbackRef === null || failCallbackRef === void 0 ? void 0 : failCallbackRef.current) && failCallbackRef.current();
                    }
                    if (cancelRisk) {
                        window.electronLib.windowManage.closeCertainWindow(winId);
                        (failCallbackRef === null || failCallbackRef === void 0 ? void 0 : failCallbackRef.current) && failCallbackRef.current();
                    }
                }
            },
        });
        navListenIdRef.current = id;
    };
    const riskManage = async (params) => {
        const { val, callback, failcallback } = params;
        const { redirect, originReq } = val;
        const { req, email } = originReq || {};
        const { isSubAccount, sessionName } = req || {};
        if (redirect) {
            sucCallbackRef.current = callback;
            failCallbackRef.current = failcallback;
            try {
                const res = await loginApi.pushQsid({ sessionName });
                if (res.data.code !== 200 || !res.data.data)
                    return;
                const { pullToken } = res.data.data;
                const deviceInfo = await systemApi.getDeviceInfo();
                const originParam = Object.assign({}, (originReq.req || {}));
                delete originParam['password'];
                const targetUrl = `${redirect}&pullToken=${pullToken || ''}&p=${deviceInfo.p || 'sirius'}&riskSafeParam=${encodeURIComponent(JSON.stringify(originParam))}`;
                if (isElectron()) {
                    const curWin = await window.electronLib.windowManage.getCurWindow();
                    systemApi.openNewWindow(targetUrl, true, [{ observerWinId: curWin.id, hooksName: 'onWillNavigate', enable: true, intercept: false }], undefined, undefined, !sessionName || !sessionName.length ? undefined : `memory-risk-${new Date().getTime()}`, false);
                    originReqRef.current = originReq;
                    startWillNavigateListen();
                }
                else {
                    console.log('开始风控校验', targetUrl);
                    if (sessionName) {
                        window.open(targetUrl);
                    }
                    else {
                        window.location.href = targetUrl;
                    }
                }
            }
            catch (e) {
                console.error('风险校验失败', e);
            }
        }
    };
    useEffect(() => {
        return () => {
            (navListenIdRef === null || navListenIdRef === void 0 ? void 0 : navListenIdRef.current) && eventApi.unregisterSysEventObserver('willNavigate', navListenIdRef === null || navListenIdRef === void 0 ? void 0 : navListenIdRef.current);
        };
    }, []);
    return { riskManage };
};
export default useRisk;
